// Retail Profile Actions
export const CREATE_RETAIL_PROFILE = 'CREATE_RETAIL_PROFILE';
export const CREATE_RETAIL_PROFILE_SUCCESS = 'CREATE_RETAIL_PROFILE_SUCCESS';
export const CREATE_RETAIL_PROFILE_FAILED = 'CREATE_RETAIL_PROFILE_FAILED';

export const GET_RETAIL_PROFILES = 'GET_RETAIL_PROFILES';
export const GET_RETAIL_PROFILES_SUCCESS = 'GET_RETAIL_PROFILES_SUCCESS';
export const GET_RETAIL_PROFILES_FAILED = 'GET_RETAIL_PROFILES_FAILED';

export const GET_RETAIL_PROFILE_BY_ID = 'GET_RETAIL_PROFILE_BY_ID';
export const GET_RETAIL_PROFILE_BY_ID_SUCCESS = 'GET_RETAIL_PROFILE_BY_ID_SUCCESS';
export const GET_RETAIL_PROFILE_BY_ID_FAILED = 'GET_RETAIL_PROFILE_BY_ID_FAILED';

export const GET_RETAIL_PROFILES_BY_VENUE = 'GET_RETAIL_PROFILES_BY_VENUE';
export const GET_RETAIL_PROFILES_BY_VENUE_SUCCESS = 'GET_RETAIL_PROFILES_BY_VENUE_SUCCESS';
export const GET_RETAIL_PROFILES_BY_VENUE_FAILED = 'GET_RETAIL_PROFILES_BY_VENUE_FAILED';

export const UPDATE_RETAIL_PROFILE = 'UPDATE_RETAIL_PROFILE';
export const UPDATE_RETAIL_PROFILE_SUCCESS = 'UPDATE_RETAIL_PROFILE_SUCCESS';
export const UPDATE_RETAIL_PROFILE_FAILED = 'UPDATE_RETAIL_PROFILE_FAILED';

export const DELETE_RETAIL_PROFILE = 'DELETE_RETAIL_PROFILE';
export const DELETE_RETAIL_PROFILE_SUCCESS = 'DELETE_RETAIL_PROFILE_SUCCESS';
export const DELETE_RETAIL_PROFILE_FAILED = 'DELETE_RETAIL_PROFILE_FAILED';

// Retail Schedule Actions
export const CREATE_RETAIL_SCHEDULE = 'CREATE_RETAIL_SCHEDULE';
export const CREATE_RETAIL_SCHEDULE_SUCCESS = 'CREATE_RETAIL_SCHEDULE_SUCCESS';
export const CREATE_RETAIL_SCHEDULE_FAILED = 'CREATE_RETAIL_SCHEDULE_FAILED';

export const GET_SCHEDULES_BY_PROFILE = 'GET_SCHEDULES_BY_PROFILE';
export const GET_SCHEDULES_BY_PROFILE_SUCCESS = 'GET_SCHEDULES_BY_PROFILE_SUCCESS';
export const GET_SCHEDULES_BY_PROFILE_FAILED = 'GET_SCHEDULES_BY_PROFILE_FAILED';

export const GET_SCHEDULES_BY_DAY = 'GET_SCHEDULES_BY_DAY';
export const GET_SCHEDULES_BY_DAY_SUCCESS = 'GET_SCHEDULES_BY_DAY_SUCCESS';
export const GET_SCHEDULES_BY_DAY_FAILED = 'GET_SCHEDULES_BY_DAY_FAILED';

export const UPDATE_RETAIL_SCHEDULE = 'UPDATE_RETAIL_SCHEDULE';
export const UPDATE_RETAIL_SCHEDULE_SUCCESS = 'UPDATE_RETAIL_SCHEDULE_SUCCESS';
export const UPDATE_RETAIL_SCHEDULE_FAILED = 'UPDATE_RETAIL_SCHEDULE_FAILED';

export const DELETE_RETAIL_SCHEDULE = 'DELETE_RETAIL_SCHEDULE';
export const DELETE_RETAIL_SCHEDULE_SUCCESS = 'DELETE_RETAIL_SCHEDULE_SUCCESS';
export const DELETE_RETAIL_SCHEDULE_FAILED = 'DELETE_RETAIL_SCHEDULE_FAILED';

export const SET_CURRENT_RETAIL_PROFILE = 'SET_CURRENT_RETAIL_PROFILE';
export const CLEAR_RETAIL_PROFILE_STATE = 'CLEAR_RETAIL_PROFILE_STATE';
